import { injectable, interfaces } from 'inversify';
import { action, computed, makeObservable, observable } from 'mobx';

export interface IAuthStore {
  readonly token: string;
  readonly isAuthenticated: boolean;
  readonly routeReferrer: string;
  readonly lockoutDate?: string;
  readonly versionChanged: boolean;
  readonly showPlanModal: boolean;

  updateToken(token: string): void;
  clearToken(): void;
  setShowPlanModal(show: boolean): void;
  setVersionChanged(changed?: boolean): void;
  setRouteReferrer(routeReferrer: string): void;
  setLockoutDate(lockoutDate: string | undefined): void;
}

export namespace IAuthStore {
  export const $: interfaces.ServiceIdentifier<IAuthStore> = Symbol('AUTH_STORE');
}

@injectable()
export class AuthStore implements IAuthStore {
  token: string = '';

  routeReferrer: string = '';

  lockoutDate?: string = undefined;

  versionChanged: boolean = false;

  showPlanModal: boolean = false;

  constructor() {
    makeObservable(this, {
      token: observable,
      routeReferrer: observable,
      lockoutDate: observable,
      versionChanged: observable,
      showPlanModal: observable,
      updateToken: action,
      clearToken: action,
      setVersionChanged: action,
      setRouteReferrer: action,
      setLockoutDate: action,
      setShowPlanModal: action,
      isAuthenticated: computed,
    });
  }

  updateToken(token: string): void {
    this.token = token;
  }

  setShowPlanModal(show: boolean): void {
    this.showPlanModal = show;
  }

  clearToken(): void {
    this.token = '';
  }

  setVersionChanged(changed: boolean = true): void {
    this.versionChanged = changed;
  }

  setRouteReferrer(routeReferrer: string): void {
    this.routeReferrer = routeReferrer;
  }

  setLockoutDate(lockoutDate: string): void {
    this.lockoutDate = lockoutDate;
  }

  get isAuthenticated(): boolean {
    return !!this.token;
  }
}
